// extracted by mini-css-extract-plugin
module.exports = {"BarChart":"BarChart_BarChart__1mMpb"};